module.exports = __webpack_public_path__ + "img/UTQUAI-2.5be02d42.jpg";